module.exports = __webpack_public_path__ + "img/icon-save.d5031756.png";